module.exports = __webpack_public_path__ + "static/media/design6.b205d209.png";